

class Gallery {
    constructor($el) {
        this.$el = $el;
        this.$items = this.$el.find('[data-gallery="item"]');
        this.$iconContainer = this.$el.find('[data-icons="el"]');
        this.difficulty = parseInt(this.$iconContainer.attr('data-difficulty')) || 5;

        this.init();
    }

    init = () => {
        this.addIcons();


    }

    calculateOffset = () => {
        const { $slider } = this;
        const sliderWidth = $slider.width();
        const sliderScrollWidth = $slider.get(0).scrollWidth;
        const sliderWidthDiff = sliderScrollWidth - sliderWidth;

        return Math.max(0, sliderWidthDiff);
    }

            addIcons = () => {
            this.$items.find('[data-icons="el"]').each((i, iconEl) => {
                const $iconEl = $(iconEl);
                const difficulty = parseInt($iconEl.attr('data-difficulty')) || 5;
                const color = $iconEl.data('color') || '#FFFF05';

                const svgIcon = `
      <svg width="0.8rem" height="0.8rem" viewBox="0 0 21 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <title>Group Copy 7</title>
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Group-Copy-7" transform="translate(-2, -14)">
                <g id="Group-Copy-20" transform="translate(1, 34)">
                    <g transform="translate(1, -20)">
                        <rect id="Rectangle-5" fill="${color}" x="0" y="9.68" width="20.24" height="12.32"></rect>
                        <rect id="Rectangle-6" stroke="${color}" stroke-width="3.52" x="4.4" y="1.76" width="11.44" height="14.08" rx="5.72"></rect>
                    </g>
                </g>
            </g>
        </g>
      </svg>
    `;

                $iconEl.empty();

                for (let i = 0; i < 5; i++) {
                    const $icon = $('<div class="difficulty__icon"></div>').html(svgIcon);
                    if (i < difficulty) {
                        $icon.addClass('active');
                    }
                    $iconEl.append($icon);
                }
            });

        };
}

export default Gallery;